import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../types/types';
import { openBoardSettings } from '../../../../../../base/effects/openBoardSettings';
import { SegmentBoardSettingsSourceValue } from '../../../../../../../../middlewares/segment/trackEntities/boardEvents';

export function onOpenSettings (): ThunkAction {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
       dispatch(openBoardSettings('card-properties', SegmentBoardSettingsSourceValue.KANBAN_CARD_PREVIEW_SETTINGS));
    };
    return action;
}
